import { connect } from "react-redux";
import { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const BusinessesCharts = ({ stats, currency, periods }) => {
	const totalBusinesses = useMemo(() => {
		if (!stats) return [];
		const notAllowedKeys = ["plan", "count"];
		// Flatten the array of arrays into a single array
		const flattenedColumns = stats.flatMap((entry) =>
			Object.entries(entry?.businesses)
				.filter(([key]) => !notAllowedKeys.includes(key))
				.map(([key, value]) => ({
					name: key
						.replace(/([A-Z])/g, " $1")
						.trim()
						.toLowerCase()
						.replace(/^\w/, (c) => c.toUpperCase()), // Format the key name
					data: Array.isArray(value) ? value : [value], // Ensure data is an array
				})),
		);

		// Group by name
		const groupedByName = flattenedColumns.reduce((acc, { name, data }) => {
			if (!acc[name]) {
				acc[name] = { name, data: [] };
			}
			acc[name].data.push(...data);
			return acc;
		}, {});

		// Convert the grouped object back into an array
		const result = Object.values(groupedByName).map(({ name, data }) => ({
			name,
			data: data.flat(), // Flatten the data arrays into a single array
		}));

		// Calculate Individual data
		const independentData = stats.map((entry) => {
			const count = entry?.businesses?.count || 0;
			const paidByAdvisor = entry?.businesses?.paidByAdvisor || 0;
			return count - paidByAdvisor;
		});

		// Append Individual object
		result.push({
			name: "Independent",
			data: independentData,
		});

		// Sort the result based on the first entry of the data array in descending order
		const sortedResult = result.sort((a, b) => {
			const firstA = a.data[0] || 0; // Fallback to 0 if data is empty
			const firstB = b.data[0] || 0; // Fallback to 0 if data is empty
			return firstB - firstA; // For descending order
		});

		return sortedResult;
	});

	const totalBusinessesChartOptions = {
		chart: {
			type: "column",
			backgroundColor: "transparent",
		},
		credits: false,
		title: {
			text: "Total Businesses",
		},
		series: totalBusinesses,
		xAxis: {
			categories: periods,
		},
		yAxis: {
			min: 0,
			title: {
				text: "Businesses",
			},
			stackLabels: {
				enabled: true,
			},
		},
		tooltip: {
			headerFormat: "<b>{point.x}</b><br/>",
			pointFormat: "{series.name}: {point.y}<br/>Total: {point.stackTotal}",
		},
		plotOptions: {
			column: {
				stacking: "normal",
				dataLabels: {
					enabled: true,
				},
			},
		},
	};

	return (
		<>
			<div className="form-section col-span-3">
				<div className="col-span-3">
					<HighchartsReact
						highcharts={Highcharts}
						options={totalBusinessesChartOptions}
					/>
				</div>
				<div className="clearfix" />
			</div>
		</>
	);
};

const mapStateToProps = (state) => {};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(BusinessesCharts);
